import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { Typography, Box } from '@mui/material';

const StrikeZoneChart = ({ strikes, balls, hits }) => {
  const total = strikes + balls + hits;

  if (total === 0) {
    return (
      <Box sx={{ height: 250, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography variant="body2" color="text.secondary">No Data</Typography>
      </Box>
    );
  }

  const data = [
    { name: 'Strikes', value: strikes },
    { name: 'Balls', value: balls },
    { name: 'Hits', value: hits },
  ].filter(item => item.value > 0);

  // Color mapping based on name
  const getColor = (name) => {
    switch(name) {
      case 'Strikes': return '#ffeb3b'; // Yellow
      case 'Balls': return '#4caf50'; // Green
      case 'Hits': return '#9c27b0'; // Purple
      default: return '#8884d8';
    }
  };

  return (
    <Box sx={{ width: '100%', height: 250 }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={80}
            fill="#8884d8"
            paddingAngle={5}
            dataKey="value"
            isAnimationActive={false}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={getColor(entry.name)} />
            ))}
          </Pie>
          <Tooltip />
          <Legend verticalAlign="bottom" height={36}/>
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default StrikeZoneChart;

